import { forwardRef } from "react";

type DropDownToggleButtonProps = {
  children: React.ReactNode,
  onClick: (e: React.MouseEvent) => void
}

export const DropDownToggleButton = forwardRef(
  ({ onClick, children }: DropDownToggleButtonProps, ref?: React.LegacyRef<HTMLButtonElement>) => (
    <button
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </button>
  )
);
